import Vue from 'vue'

export function validateForm(fields) {
  fields.forEach(field => {
    if (field.validate) field.validate()
  })
}

export function isFormValid(fields) {
  return fields.every(field => field.getIsValid())
}

/**
 * Make sure no scroll jump occurs after showing the specific errors below the fields. Without this
 * function, the submit button will be pushed down after showing the errors which appears jumpy due
 * to the fact that the errors appear instantly.
 *
 * @example
 *
 * await fixScrollPositionOnError({
 *   submitButton: this.$refs.submitButton.$el,
 *   formValidationHandler: () => validateForm(fields),
 *   fromValidationChecker: () => isFormValid(fields),
 * })
 */
export async function fixScrollPositionOnError(params) {
  const defaultParams = {
    scrollingElement: window,
    submitButton: null,
    formValidationHandler: () => {},
    fromValidationChecker: () => {},
  }
  const options = { ...defaultParams, ...params }
  const getSubmitButtonTop = () => options.submitButton.getBoundingClientRect().top
  const buttonTopBefore = getSubmitButtonTop()

  options.formValidationHandler()
  await Vue.nextTick() // wait for the errors to be rendered
  const isValid = options.fromValidationChecker()

  if (!isValid) {
    const buttonTopAfter = getSubmitButtonTop()
    options.scrollingElement.scrollBy(0, buttonTopAfter - buttonTopBefore)
  }
}
